import { createFeatureSelector } from '@ngrx/store';
import { AgenasDisciplineState } from './agenas-discipline.entity';

export const AGENAS_DISCIPLINE_FEATURE_NAME: string = 'agenasdisciplinetypes';

export const selectAgenasDisciplineState = createFeatureSelector<AgenasDisciplineState>(AGENAS_DISCIPLINE_FEATURE_NAME);
